import ObjectUtil from '@/utils/object-util'
import Store from '@/store'

import {MUTATE_POP_NAV_HISTORY, MUTATE_PUSH_NAV_HISTORY} from '@/store/types'

function getRouteParamsToStoreInNavHistory(route) {
  const excludeParams = route.meta.excludedParamsOnNavistory || [];
  const hasExcluded = excludeParams.length > 0;

  const params = {};

  const fromParamKeys = Object.keys(route.params);
  fromParamKeys.forEach(k => {
    if (!hasExcluded || excludeParams.indexOf(k) < 0) {
      const val = route.params[k];
      if (typeof val === 'object' && val != null) {
        params[k] = ObjectUtil.cloneObject(val);
      } else {
        params[k] = val
      }
    }
  });

  return params;
}

export default ((to, from) => {
  const fromLevel = from.meta.level || 0;
  const toLevel = to.meta.level || 0;

  if (toLevel > fromLevel) {
    if (from.path !== '/') {
      const params = getRouteParamsToStoreInNavHistory(from);
      const query = {...(from.query || {})}
      Store.commit(MUTATE_PUSH_NAV_HISTORY, {params, name: from.name, query});
    }
  } else if (fromLevel > toLevel) {
    Store.commit(MUTATE_POP_NAV_HISTORY);
  }

});